import { sep } from "path"
import { IsBeta } from "../utils/Network"
import { Assets } from "./assets"

/**
 * Bulk-repair promotion window — the "Special Offer" tiers in the building
 * detail dialog are surfaced only while this date is in the future.
 *
 * The tier percentages are computed client-side from how much health a repair
 * restores (see calculateHpDelta in pages/village/BuildingDetailDialog.tsx).
 * The server is what actually bills the repair, so this flag controls whether
 * the offer is *shown*, not what the player is charged.
 *
 * Currently set to 2026-08-31 23:00 UTC.
 */
export const RepairPromotionEnd = Date.UTC(2026, 7, 31, 23, 0, 0, 0)

export const TokenLock = {
    id: "tokenlock",
    start: {
        date: Date.UTC(2023, 10, 15, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/tokenlock/coming.webp',
    },
    end: {
        date: Date.UTC(2023, 10, 30, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/tokenlock/started.webp',
    },
    remove: {
        date: Date.UTC(2023, 10, 31, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/tokenlock/ended.webp',
    },
    descriptionKey: "events.descriptions.tokenlock"
}


export const BlackFriday = {
    id: "black-friday",
    start: {
        date: Date.UTC(2023, 10, 23, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/black-friday/coming.webp',
    },
    end: {
        date: Date.UTC(2023, 10, 25, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/black-friday/started.webp',
    },
    remove: {
        date: Date.UTC(2023, 10, 27, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/black-friday/ended.webp',
    },
    descriptionKey: "events.descriptions.black-friday"
}

export const Christmas = {
    id: "christmas",
    start: {
        date: "2023-12-01T13:30:00+0330",
        asset: '/assets/images/campaigns/christmas/coming.webp',
    },
    end: {
        date: "2023-12-14T13:30:00+0330",
        asset: '/assets/images/campaigns/christmas/started.webp',
    },
    remove: {
        date: "2023-12-16T13:30:00+0330",
        asset: '/assets/images/campaigns/christmas/ended.webp',
    },
    descriptionKey: "events.descriptions.christmas"
}

export const ChristmasStarted = {
    id: "christmas-started",
    start: {
        date: Date.UTC(2023, 11, 16, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/christmas-started/coming.webp',
    },
    end: {
        date: Date.UTC(2023, 11, 28, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/christmas-started/started.webp',
    },
    remove: {
        date: Date.UTC(2023, 11, 29, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/christmas-started/ended.webp',
    },
    descriptionKey: "events.descriptions.christmas-started"
}





export const GuildEvent = {
    id: "guild",
    timer: "/assets/images/campaigns/guild/timer1.webp",
    start: {
        date: IsBeta ? Date.UTC(2024, 1, 1, 10, 0, 0, 0) : Date.UTC(2024, 1, 1, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/guild/coming.webp',
    },
    end: {
        date: Date.UTC(2024, 2, 1, 0, 0, 0, 0),
        asset: '/assets/images/campaigns/guild/started.webp',
    },
    remove: {
        date: Date.UTC(2024, 2, 2, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/guild/ended.webp',
    },
    descriptionKey: "events.descriptions.guild"
}


export const LunarEvent = {
    id: "lunar",
    timer: "/assets/images/campaigns/lunar/timer.webp",
    start: {
        date: IsBeta ? Date.UTC(2024, 1, 1, 10, 0, 0, 0) : Date.UTC(2024, 1, 1, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/lunar/coming.webp',
    },
    end: {
        date: Date.UTC(2024, 2, 1, 0, 0, 0, 0),
        asset: '/assets/images/campaigns/lunar/started.webp',
    },
    remove: {
        date: Date.UTC(2024, 2, 2, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/lunar/ended.webp',
    },
    descriptionKey: "events.descriptions.lunar"
}


export const JuneEvent = {
    id: "egg",
    timer: "/assets/images/campaigns/lunar/timer.webp",
    start: {
        date: Date.UTC(2024, 5, 1, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/june/event-borad-challenge-june-barracks.png',
    },
    end: {
        date: Date.UTC(2024, 6, 1, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/june/event-borad-challenge-june-barracks.png',
    },
    remove: {
        date: Date.UTC(2024, 6, 2, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/june/event-borad-challenge-june-barracks.png',
    },
    descriptionKey: "events.descriptions.egg"
}


export const Challenge = {
    id: 'challenge',
    timer: "/assets/images/campaigns/challenge-timer.webp",
    start: {
        date: Date.UTC(2024, 8, 1, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/event-board-sep-challenge.webp',
    },
    end: {
        date: Date.UTC(2024, 9, 1, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/event-board-sep-challenge.webp',
    },
    remove: {
        date: Date.UTC(2024, 9, 2, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/event-board-sep-challenge.webp',
    },
    descriptionKey: "events.descriptions.challenge"
}



const augustEvent = {
    id: "august",
    timer: "/assets/images/campaigns/august/timer.webp",
    start: {
        date: Date.UTC(2024, 7, 1, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/august/coming.webp',
    },
    end: {
        date: Date.UTC(2024, 8, 1, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/august/started.webp',
    },
    cycles: [
        {
            id: "august-1",
            startDate: Date.UTC(2024, 7, 1, 10, 0, 0, 0),
            asset: '/assets/images/campaigns/august/event-board-august-1.webp',
            link: "/home#upgrade-cleg",
        },
        {
            id: "august-2",
            startDate: Date.UTC(2024, 7, 6, 10, 0, 0, 0),
            asset: '/assets/images/campaigns/august/event-board-august-2.webp',
            link: "/home#upgrade-stone",
        },
        {
            id: "august-3",
            startDate: Date.UTC(2024, 7, 11, 10, 0, 0, 0),
            asset: '/assets/images/campaigns/august/event-board-august-3.webp',
            link: "/home#upgrade-iron",

        },
        {
            id: "august-4",
            startDate: Date.UTC(2024, 7, 16, 10, 0, 0, 0),
            asset: '/assets/images/campaigns/august/event-board-august-4.webp',
            link: "/home#upgrade-barracks",

        },
        {
            id: "august-5",
            startDate: Date.UTC(2024, 7, 21, 10, 0, 0, 0),
            asset: '/assets/images/campaigns/august/event-board-challenge-august-5.webp',
            link: "/barracks",

        },
    ]
}

const septemberEvent = {
    id: "september",
    timer: "https://static.chainoflegends.com/images/campaigns/arena-campaign/timeer-box.webp",
    link: '/arena/leader-board/lords',
    start: {
        date: Date.UTC(2024, 9, 1, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/august/coming.webp',
    },
    end: {
        date: Date.UTC(2024, 10, 1, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/august/started.webp',
    },
    cycles: [
        {
            id: "september-1",
            startDate: Date.UTC(2024, 9, 1, 10, 0, 0, 0),
            asset: "https://static.chainoflegends.com/images/campaigns/arena-campaign/Event-borad-arena-battle-new-1-up.webp",
        },
        {
            id: "september-2",
            startDate: Date.UTC(2024, 9, 7, 10, 0, 0, 0),
            asset: "https://static.chainoflegends.com/images/campaigns/arena-campaign/Event-borad-arena-battle-new-1-live.webp",
        },
        {
            id: "september-3",
            startDate: Date.UTC(2024, 9, 14, 10, 0, 0, 0),
            asset: "https://static.chainoflegends.com/images/campaigns/arena-campaign/Event-borad-arena-battle-new-2-up.webp",

        },
        {
            id: "september-4",
            startDate: Date.UTC(2024, 9, 21, 10, 0, 0, 0),
            asset: "https://static.chainoflegends.com/images/campaigns/arena-campaign/Event-borad-arena-battle-new-2-live.webp",
        },
        {
            id: "september-5",
            startDate: Date.UTC(2024, 9, 26, 10, 0, 0, 0),
            asset: "https://static.chainoflegends.com/images/campaigns/arena-campaign/Event-borad-arena-battle-new-3-up.webp",
        },
    ]
}
const octoberEvent = {
    id: "october",
    timer: "https://static.chainoflegends.com/images/campaigns/october-arena/timeer-box.png",
    start: {
        date: Date.UTC(2024, 9, 1, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/august/coming.webp',
    },
    end: {
        date: Date.UTC(2024, 10, 1, 10, 0, 0, 0),
        asset: '/assets/images/campaigns/august/started.webp',
    },
    cycles: [
        {
            id: "october-1",
            startDate: Date.UTC(2024, 9, 1, 10, 0, 0, 0),
            asset: "https://static.chainoflegends.com/images/campaigns/october-arena/october-discounts-Event-board-1.png",
            link: "/home#upgrade-cleg",

        },
        {
            id: "october-2",
            startDate: Date.UTC(2024, 9, 6, 10, 0, 0, 0),
            asset: "https://static.chainoflegends.com/images/campaigns/october-arena/october-discounts-Event-board-2.png",
            link: "/home#upgrade-stone",
        },
        {
            id: "october-3",
            startDate: Date.UTC(2024, 9, 11, 10, 0, 0, 0),
            asset: "https://static.chainoflegends.com/images/campaigns/october-arena/october-discounts-Event-board-3.png",
            link: "/home#upgrade-iron",

        },
        {
            id: "october-4",
            startDate: Date.UTC(2024, 9, 16, 10, 0, 0, 0),
            asset: "https://static.chainoflegends.com/images/campaigns/october-arena/october-discounts-Event-board-4.png",
            link: "/home#upgrade-barracks",
        },
        {
            id: "october-5",
            startDate: Date.UTC(2024, 9, 25, 10, 0, 0, 0),
            asset: "https://static.chainoflegends.com/images/campaigns/october-arena/october-discounts-Event-board-5.png",
            link: "/barracks",

        },
    ]
}

export const ReferralBountyEvent = {
    id: "bounty-x",
    timer: "https://static.chainoflegends.com/images/campaigns/referral/timer.webp",
    start: {
        date: Date.UTC(2025, 1, 15, 10, 0, 0, 0),
        asset: 'https://static.chainoflegends.com/images/campaigns/referral/event-board-referral-new.webp',
    },
    end: {
        date: Date.UTC(2025, 1, 28, 10, 0, 0, 0),
        asset: 'https://static.chainoflegends.com/images/campaigns/referral/event-board-referral-new.webp',
    },
    remove: {
        date: Date.UTC(2025, 1, 29, 10, 0, 0, 0),
        asset: 'https://static.chainoflegends.com/images/campaigns/referral/event-board-referral-new.webp',
    },
    descriptionKey: "events.descriptions.bounty-x"
}

export const ReferralEvent = {
    id: "ref-x",
    timer: "https://static.chainoflegends.com/images/campaigns/timer1.webp",
    start: {
        date: Date.UTC(2025, 0, 29, 10, 0, 0, 0),
        asset: Assets.campaigns.referral,
    },
    end: {
        date: Date.UTC(2025, 1, 16, 10, 0, 0, 0),
        asset: Assets.campaigns.referral,
    },
    remove: {
        date: Date.UTC(2025, 1, 21, 10, 0, 0, 0),
        asset: Assets.campaigns.referral,
    },
    descriptionKey: "events.descriptions.ref-x"
}

export default [ReferralBountyEvent]
